import styled from '@emotion/styled';
import { Grid } from '@mui/material';

export const Buttons = styled('div')({
  width: '100%',
  display: 'flex',
  justifyContent: 'flex-end',
  '& .MuiIconButton-root': {
    marginLeft: '5px',
  },
});

export const GridWrap = styled(Grid)({
  marginTop: 5,
});
